import EcoTab, { EcoTabItemProps } from 'eco-design/elements/eco-tab';
import React, { useMemo, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';
import { Pagination, EffectFade } from 'swiper';
import { useLang } from '@/i18n';
import EFCoffeeMaker from 'elem/ui-assets/icons/appliances/EFCoffeeMaker';
import EFElectricGrill from 'elem/ui-assets/icons/appliances/EFElectricGrill';
import EFFan from 'elem/ui-assets/icons/appliances/EFFan';
import EFLight from 'elem/ui-assets/icons/appliances/EFLight';
import EFLaptop from 'elem/ui-assets/icons/appliances/EFLaptop';
import EFMicrowave from 'elem/ui-assets/icons/appliances/EFMicrowave';
import EFPhone from 'elem/ui-assets/icons/appliances/EFPhone';
import EFRefrigerator from 'elem/ui-assets/icons/appliances/EFRefrigerator';
import EFTV from 'elem/ui-assets/icons/appliances/EFTV';

import { Router } from '../../icons/index';
import EfSpec from '@elem/ui/ef-spec';

type RowIcon = { title: string; icon: React.ReactNode };
type RowIconDesc = { title: string; desc: string; icon: React.ReactNode };


const ModemIcon = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
        <path d="M4.96889 16.12H7.45333V18.6044H4.96889V16.12ZM9.88 16.12H12.3644V18.6044H9.88V16.12ZM0 22.7644C0 23.5733 0.404444 24.3822 0.924444 25.0756C1.44444 25.7689 2.25333 26 3.23556 26H22.7644C23.5733 26 24.3822 25.5956 25.0756 25.0756C25.5956 24.5556 26 23.5733 26 22.7644V14.6756C26 13.0578 24.6711 11.5556 23.0533 11.44H22.9378V0.808889C22.9378 0.404445 22.5333 0 22.1289 0C21.84 0 21.7244 0.115556 21.6089 0.288889C21.4933 0.404444 21.32 0.693333 21.32 0.808889V11.44H4.85333V0.808889C4.85333 0.404445 4.44889 0 4.04444 0C3.75556 0 3.64 0.115556 3.52444 0.288889C3.23556 0.404444 3.12 0.693333 3.12 0.808889V11.44H2.94667C1.32889 11.5556 0 12.9422 0 14.6756V22.7644ZM1.73333 14.6756C1.73333 13.8667 2.42667 13.0578 3.35111 13.0578H22.7644C23.5733 13.0578 24.3822 13.7511 24.3822 14.6756V22.7644C24.3822 23.5733 23.6889 24.3822 22.7644 24.3822H3.23556C2.42667 24.3822 1.61778 23.6889 1.61778 22.7644V14.6756H1.73333ZM6.93333 3.29333C8.60889 1.67556 10.7467 0.577778 13.1156 0.577778C15.6578 0.577778 17.7956 1.56 19.4711 3.29333L18.8356 4.04444C17.3333 2.6 15.3111 1.61778 13.1156 1.61778C10.92 1.61778 8.95556 2.54222 7.56889 4.04444L6.93333 3.29333ZM10.1111 7.45333C10.8622 6.70222 12.0178 6.12444 13.2889 6.12444C14.4444 6.12444 15.5422 6.58667 16.4667 7.45333L15.8311 8.20444C15.1956 7.56889 14.1556 7.22222 13.2889 7.22222C12.2489 7.22222 11.4978 7.45333 10.7467 8.20444L10.1111 7.45333ZM8.49333 5.37333C9.76444 4.16 11.3822 3.29333 13.1733 3.40889C14.9644 3.40889 16.5822 4.27556 17.8533 5.48889L17.2178 6.24C16.1778 5.14222 14.6756 4.39111 13.1733 4.39111C11.6711 4.39111 10.2844 5.14222 9.12889 6.12444L8.49333 5.37333Z" fill="#707070" />
    </svg>
}

const SecurityProtection = () => {
    const swiperRef = useRef<any>(null);
    const [activeTabIndex, setActiveTabIndex] = useState<number>(0);
    const { t } = useLang('delta3series');

    const items = [
        { tabValue: 'a1', tabLabel: t('SP_item1_tab') },
        { tabValue: 'a2', tabLabel: t('SP_item2_tab') },
        { tabValue: 'a3', tabLabel: t('SP_item3_tab') },
    ];

    const contentList = useMemo(
        () => [
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1776334418782/1kWh%E7%BB%84%E5%90%88%20(1).png',
                desc: t('SP_item1_text'),
                hoursRow1: 'SP_security_row1_hours',
                hoursRow2: 'SP_security_row2_hours',
                // footerDesc: "SP_security_1_desc",
                row1: [
                    { title: t('SP_security_1'), icon: <ModemIcon /> },
                    { title: t('SP_security_2'), icon: <Router /> },
                    { title: t('SP_security_3'), icon: <EFLaptop /> },
                    { title: t('SP_security_4'), icon: <EFPhone /> },
                    { title: t('SP_security_5'), icon: <EFLight /> },
                ] as RowIcon[],
                row2: [
                    { title: t('SP_security_6'), icon: <EFTV /> },
                    { title: t('SP_security_7'), icon: <EFFan /> },
                ] as RowIcon[],
                row3: [
                    {
                        title: t('SP_security_8'),
                        desc: t('SP_security_blender1_1'), icon: <EFRefrigerator />
                    },
                    {
                        title: t('SP_security_9'),
                        desc: t('SP_security_blender1_2'),
                        icon: <EFMicrowave />,
                    },
                    {
                        title: t('SP_security_10'),
                        desc: t('SP_security_blender1_3'), icon: <EFCoffeeMaker />
                    },
                    {
                        title: t('SP_security_11'),
                        desc: t('SP_security_blender1_4'), icon: <EFElectricGrill />
                    },
                ] as RowIconDesc[],
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1776322342521/2kWh%E7%BB%84%E5%90%88.png',
                desc: t('SP_item2_text'),
                hoursRow1: 'SP_security_row3_hours',
                hoursRow2: 'SP_security_row4_hours',
                // footerDesc: "SP_security_2_desc",
                row1: [
                    { title: t('SP_security_1'), icon: <ModemIcon /> },
                    { title: t('SP_security_2'), icon: <Router /> },
                    { title: t('SP_security_3'), icon: <EFLaptop /> },
                    { title: t('SP_security_4'), icon: <EFPhone /> },
                    { title: t('SP_security_5'), icon: <EFLight /> },
                ] as RowIcon[],
                row2: [
                    { title: t('SP_security_6'), icon: <EFTV /> },
                    { title: t('SP_security_7'), icon: <EFFan /> },
                ] as RowIcon[],
                row3: [
                    {
                        title: t('SP_security_8'),
                        desc: t('SP_security_blender2_1'), icon: <EFRefrigerator />
                    },
                    {
                        title: t('SP_security_9'),
                        desc: t('SP_security_blender2_2'),
                        icon: <EFMicrowave />,
                    },
                    {
                        title: t('SP_security_10'),
                        desc: t('SP_security_blender2_3'), icon: <EFCoffeeMaker />
                    },
                    {
                        title: t('SP_security_11'),
                        desc: t('SP_security_blender2_4'), icon: <EFElectricGrill />
                    },
                ] as RowIconDesc[],
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1775273985836/5kWh%E7%BB%84%E5%90%88.png',
                desc: t('SP_item3_text'),
                hoursRow1: 'SP_security_row5_hours',
                hoursRow2: 'SP_security_row6_hours',
                // footerDesc: "SP_security_3_desc",
                row1: [
                    { title: t('SP_security_1'), icon: <ModemIcon /> },
                    { title: t('SP_security_2'), icon: <Router /> },
                    { title: t('SP_security_3'), icon: <EFLaptop /> },
                    { title: t('SP_security_4'), icon: <EFPhone /> },
                    { title: t('SP_security_5'), icon: <EFLight /> },
                ] as RowIcon[],
                row2: [
                    { title: t('SP_security_6'), icon: <EFTV /> },
                    { title: t('SP_security_7'), icon: <EFFan /> },
                ] as RowIcon[],
                row3: [
                    {
                        title: t('SP_security_8'),
                        desc: t('SP_security_blender3_1'), icon: <EFRefrigerator />
                    },
                    {
                        title: t('SP_security_9'),
                        desc: t('SP_security_blender3_2'),
                        icon: <EFMicrowave />,
                    },
                    {
                        title: t('SP_security_10'),
                        desc: t('SP_security_blender3_3'), icon: <EFCoffeeMaker />
                    },
                    {
                        title: t('SP_security_11'),
                        desc: t('SP_security_blender3_4'), icon: <EFElectricGrill />
                    },
                ] as RowIconDesc[],
            },
        ],
        [t]
    );

    const toggleItemHandle = (_item: EcoTabItemProps, index: number) => {
        swiperRef.current?.slideToLoop(index);
        setActiveTabIndex(index);
    };

    const onSlideChange = ({ realIndex }: { realIndex: number }) => {
        setActiveTabIndex(realIndex);
    };

    const renderIconRow = (row: RowIcon[], withBracket: boolean, hoursH5?: React.ReactNode) => (
        <div className={withBracket ? styles.slideIconsBracket : undefined}>
            <div className={styles.slideIconsCluster}>
                {row.map((it, i) => (
                    <React.Fragment key={`${it.title}-${i}`}>
                        {i > 0 && <span className={styles.slidePlus}>+</span>}
                        <div className={styles.slideIconItem}>
                            <span className={styles.slideIcon}>{it.icon}</span>
                            <span className={styles.slideIconTitle}>{it.title}</span>
                        </div>
                    </React.Fragment>
                ))}
            </div>
            {withBracket ? hoursH5 : null}
        </div>
    );

    return (
        <section className={`${styles.SecurityProtection}  GtmModuleData-section range3`} data-section-id="SecurityProtection" id='SecurityProtection'>
            <EfSpec className="spec-x" />
            <div className="title-box">
                <div className="label">{t('SP_label')}</div>
                <div className="title">{t('SP_title')}</div>
            </div>
            <div className="content-box">
                <div className={`security-swiper ${styles.swiperShell}`}>
                    <button
                        type="button"
                        className={styles.swiperNavBtnPrev}
                        aria-label="Previous slide"
                        onClick={() => swiperRef.current?.slidePrev()}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
                            <path d="M7 13L1 7L7 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                    <Swiper
                        modules={[Pagination, EffectFade]}
                        onSwiper={(swiper) => {
                            swiperRef.current = swiper;
                        }}
                        onSlideChange={onSlideChange}
                        loop={true}
                        effect={'slide'}
                        speed={800}
                        pagination
                        slidesPerView={1}
                        spaceBetween={16}
                    >
                        {contentList.map((item, index) => (
                            <SwiperSlide key={index} className={`swiper-slide ${styles.slide}`}>
                                <div className={styles.slideInner}>
                                    <div className={styles.slideLeft}>
                                        {item.desc && <p className={styles.slideDesc}>{item.desc}</p>}
                                        <div className={styles.slideRow1}>
                                            {renderIconRow(
                                                item.row1,
                                                true,
                                                <span className={styles.slideHoursH5}>{t.rich(item.hoursRow1, {
                                                    b: (text: string) => <span className='b'>{text}</span>,
                                                    sup: (tx: string) => <sup className="sup">{tx}</sup>
                                                })}</span>
                                            )}
                                            <span className={styles.slideHoursPc}>{t.rich(item.hoursRow1, {
                                                b: (text: string) => <span className='b'>{text}</span>,
                                                sup: (tx: string) => <sup className="sup">{tx}</sup>
                                            })}</span>
                                        </div>
                                        <div className={styles.slideRow2}>
                                            {renderIconRow(
                                                item.row2,
                                                true,
                                                <span className={styles.slideHoursH5}>{t.rich(item.hoursRow2, {
                                                    b: (text: string) => <span className='b'>{text}</span>
                                                })}</span>
                                            )}
                                            <span className={styles.slideHoursPc}>{t.rich(item.hoursRow2, {
                                                b: (text: string) => <span className='b'>{text}</span>
                                            })}</span>
                                        </div>
                                        <div className={styles.slideRow3}>
                                            {item.row3.map((it, i) => (
                                                <div key={`r3-${i}`} className={styles.slideIconItemCol}>
                                                    <span className={styles.slideIcon}>{it.icon}</span>
                                                    <span className={styles.slideIconTitle}>{it.title}</span>
                                                    <span className={styles.slideIconDesc}>{it.desc}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div className={styles.slideRight}>
                                        <EcoImg className={`swiper-img ${styles.slideImg}`} pc={item.pc} pad={item.pad} h5={item.h5} isOpenLazy />
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <button
                        type="button"
                        className={styles.swiperNavBtnNext}
                        aria-label="Next slide"
                        onClick={() => swiperRef.current?.slideNext()}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
                            <path d="M1 13L7 7L1 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                </div>
                <div className={`content-tab`}>
                    <EcoTab onChange={toggleItemHandle} items={items} theme={'white'} activeIndex={activeTabIndex} />
                    <div className="footer">
                        {t(contentList[activeTabIndex]?.footerDesc)}
                    </div>
                </div>

            </div>
            <EfSpec className="spec-x" />
        </section>
    );
};

export default SecurityProtection;
